import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e31fcf3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-base-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "设备信息", -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "img-box" }
const _hoisted_5 = ["src"]

import { ref, watch } from 'vue'
import Text from '@/components/text'
import { get, isEmpty } from 'lodash'
import moment from 'moment'
import { formatLat, formatLng } from '@/utils/map.utils'
import defaultImg from '@/assets/img/device/device-default.png'
import { DEVICE_STATUS_ENUM, PRODUCT_TYPE } from '@/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'device-info',
  props: ['data'],
  setup(__props) {

const deviceStatusMap = {
  [DEVICE_STATUS_ENUM.INACTIVATE]: '',
  [DEVICE_STATUS_ENUM.ONLINE]: 'success',
  [DEVICE_STATUS_ENUM.OFFLINE]: 'info',
  [DEVICE_STATUS_ENUM.NOACTIVATE]: 'warning',
}

const props = __props

watch(
  () => props.data,
  () => {
    if (!isEmpty(props.data)) {
      dealwidthData(props.data)
    }
  },
  {
    deep: true,
    immediate: true,
  }
)

const productImg = ref(defaultImg)
const deviceInfo: any = ref({})
const dealwidthData = (resData?: any) => {
  const data = resData || {}
  deviceInfo.value = data
  baseInfo.value = baseInfo.value
    .map((item: any) => {
      if (item.filter && !item.filter(data)) {
        return false
      }
      if (item.formatter) {
        return {
          ...item,
          value: item.formatter(data),
        }
      } else {
        return {
          ...item,
          value: data[item.key],
        }
      }
    })
    .filter(Boolean)
  const { productImage, productImageBaseUrl } = data
  if (productImage) {
    productImg.value = productImageBaseUrl + productImage
  }
}

const baseInfo:any = ref([
  {
    title: '所属组织 : ',
    value: '',
    key: 'topOrgName',
  },
  {
    title: '所属站点 : ',
    value: '',
    key: 'siteName',
  },
  {
    title: '所属产品 : ',
    value: '',
    key: 'productTypeValue',
  },
  {
    title: '接入方式 : ',
    value: '',
    key: 'connectType',
  },
  {
    title: 'SN : ',
    value: '',
    key: 'deviceSn',
  },
  {
    title: '创建时间 : ',
    value: '',
    key: 'createDate',
    formatter: ({ createDate }: any) => {
      return moment(createDate).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  {
    title: 'IMEI : ',
    value: '',
    key: 'imei',
    filter: ({ sgFlag }: any) => {
      return sgFlag
    },
  },
  {
    title: '设备位置 : ',
    value: '',
    key: '',
    formatter: (data: any) => {
      return get(data, 'deviceLocationInfo.deviceAddress')
    },
  },
  {
    title: '激活时间 : ',
    value: '',
    key: 'activationTime',
    formatter: ({ activationTime }: any) => {
      return activationTime
        ? moment(activationTime).format('YYYY-MM-DD HH:mm:ss')
        : '-'
    },
    filter: ({productTypeCode }: any) => {
      return  PRODUCT_TYPE.DIRECT_CONNECT !== productTypeCode
    },
  },

  {
    title: '经纬度 : ',
    value: '',
    key: 'deviceAddress',
    formatter: (data: any) => {
      if (data?.deviceLocationInfo) {
        const { latitude, longitude } = data?.deviceLocationInfo
        return (
          formatLat(latitude) +
          ' ' +
          latitude +
          '°' +
          ' ' +
          formatLng(longitude) +
          ' ' +
          longitude +
          '°'
        )
      }
      return '-'
    },
  },
  {
    title: '到期时间 : ',
    value: '',
    key: 'activeEndTime',
    formatter: ({ activeEndTime,sgFlag }: any) => {
      return sgFlag && activeEndTime
        ? moment(activeEndTime).format('YYYY-MM-DD HH:mm:ss')
        : '-'
    },
    filter: ({productTypeCode }: any) => {
      return  PRODUCT_TYPE.DIRECT_CONNECT !== productTypeCode
    },
  },
  {
    title: 'DCS状态 : ',
    value: '',
    key: 'dcsStatusValue',
    filter: ({productTypeCode }: any) => {
      return  PRODUCT_TYPE.DIRECT_CONNECT !== productTypeCode
    },
  },
  {
    title: '采集时间 : ',
    value: '',
    key: 'sendTime',
    formatter: ({ sendTime }: any) => {
      return sendTime ? moment(sendTime).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
  },
  {
    title: '最后上报时间 : ',
    value: '',
    key: 'deviceLastTime',
    formatter: ({ deviceLastTime }: any) => {
      return deviceLastTime
        ? moment(deviceLastTime).format('YYYY-MM-DD HH:mm:ss')
        : '-'
    },
  },
  {
    title: '电池电压 : ',
    value: '',
    key: 'batteryVoltage',
    formatter: ({ batteryVoltage, batteryVoltageUnit }: any) => {
      return batteryVoltage ? batteryVoltage + ' ' + batteryVoltageUnit : '-'
    },
    filter: ({ sgFlag,productTypeCode }: any) => {
      return !sgFlag && PRODUCT_TYPE.DIRECT_CONNECT !== productTypeCode
    },
  },
  {
    title: '外部供电 : ',
    value: '',
    key: 'outerBatVol',
    formatter: ({ batteryVoltage, batteryVoltageUnit }: any) => {
      const num = Number(batteryVoltage)
      if (num < 4) {
        return '无外部供电'
      }
      return batteryVoltage + ' ' + batteryVoltageUnit
    },
    filter: ({ sgFlag }: any) => {
      return sgFlag
    },
  },
  {
    title: '星历更新时间 : ',
    value: '',
    key: 'tleLastTime',
    formatter: ({ tleLastTime }: any) => {
      return tleLastTime
        ? moment(tleLastTime).format('YYYY-MM-DD HH:mm:ss')
        : '-'
    },
    filter: ({productTypeCode }: any) => {
      return  PRODUCT_TYPE.DIRECT_CONNECT !== productTypeCode
    },
  },
])

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Text), {
          content: deviceInfo.value.deviceName,
          class: "device-name"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(deviceInfo.value.deviceName), 1)
          ]),
          _: 1
        }, 8, ["content"]),
        _createElementVNode("img", {
          src: productImg.value,
          alt: ""
        }, null, 8, _hoisted_5)
      ]),
      _createVNode(_component_el_row, {
        gutter: 20,
        class: "base-info"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseInfo.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_col, {
              span: item.span || 12,
              key: index
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Text), {
                  content: item.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title) + _toDisplayString(item.value || '-'), 1)
                  ]),
                  _: 2
                }, 1032, ["content"])
              ]),
              _: 2
            }, 1032, ["span"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["status", deviceStatusMap[deviceInfo.value.deviceStatusCode]])
    }, " 状态：" + _toDisplayString(deviceInfo.value.deviceStatusName), 3)
  ]))
}
}

})